<div class="representante-legal-step">
  <!-- ==================== BLOQUEO POR CRUCE CON EL e-RUT ==================== -->
  <ng-container *ngIf="erutMismatch">
    <div class="result-banner error">
      <mat-icon>gpp_maybe</mat-icon>
      <div class="result-text">
        <span class="result-title">El e-RUT no corresponde a este representante legal</span>
        <span class="result-desc">
          El e-RUT que cargaste fue descargado del SII por otra persona. Necesitamos
          el que descarga el mismo representante legal cuya identidad verificamos.
        </span>
      </div>
    </div>

    <div class="compare-card">
      <div class="compare-row">
        <span class="compare-label">Representante verificado</span>
        <span class="compare-value">{{ rutRepresentanteLabel }}</span>
      </div>
      <div class="compare-row mismatch">
        <span class="compare-label">Descargó el e-RUT</span>
        <span class="compare-value">
          {{ rutErutLabel }}
          <small *ngIf="usuarioErutLabel !== '—'">{{ usuarioErutLabel }}</small>
        </span>
      </div>
    </div>

    <div class="actions">
      <button type="button" class="continue-btn" (click)="loadAnotherErut()">
        Cargar otro e-RUT
      </button>
      <button type="button" class="back-btn" (click)="volverAlDocumento()">
        Leer otro documento
      </button>
    </div>
  </ng-container>

  <!-- ==================== FORMULARIO ==================== -->
  <ng-container *ngIf="!erutMismatch">
    <p class="main-question"><strong>Datos del representante legal</strong></p>
    <p class="subtext">
      Verifica los datos obtenidos de tu documento y completa los campos restantes.
    </p>

    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="form-wrapper">
      <!-- Datos del OCR -->
      <div class="section-divider"><span>Datos de tu documento</span></div>

      <div class="form-grid">
        <div class="floating-group">
          <input type="text" id="rl_nombres" formControlName="nombres" readonly />
          <label for="rl_nombres">Nombres</label>
        </div>
        <div class="floating-group">
          <input type="text" id="rl_apellidos" formControlName="apellidos" readonly />
          <label for="rl_apellidos">Apellidos</label>
        </div>
      </div>

      <div class="form-grid">
        <div class="floating-group">
          <input type="text" id="rl_rut" formControlName="rut" readonly />
          <label for="rl_rut">RUT</label>
        </div>
        <div class="floating-group">
          <input type="date" id="rl_venc" formControlName="fecha_vencimiento_dni" />
          <label for="rl_venc">Vencimiento del documento</label>
        </div>
      </div>

      <p class="field-error" *ngIf="isFieldInvalid('fecha_vencimiento_dni')">
        Indica la fecha de vencimiento del documento.
      </p>

      <!-- Datos personales -->
      <div class="section-divider"><span>Datos personales</span></div>

      <div class="form-grid">
        <div class="floating-group">
          <select id="rl_nacionalidad" formControlName="nacionalidad">
            <option value="" disabled hidden></option>
            <option *ngFor="let country of countries" [value]="country.name">
              {{ country.name }}
            </option>
          </select>
          <label for="rl_nacionalidad">Nacionalidad</label>
        </div>
        <div class="floating-group">
          <input
            type="number"
            id="rl_participacion"
            formControlName="porcentaje_participacion"
            min="0"
            max="100"
          />
          <label for="rl_participacion">Participación en la empresa (%)</label>
        </div>
      </div>

      <p class="field-error" *ngIf="isFieldInvalid('porcentaje_participacion')">
        Ingresa un porcentaje entre 0 y 100.
      </p>

      <!-- Domicilio -->
      <div class="section-divider"><span>Domicilio particular</span></div>

      <div class="floating-group">
        <input type="text" id="rl_direccion" formControlName="direccion_particular" />
        <label for="rl_direccion">Dirección</label>
      </div>

      <div class="form-grid">
        <div class="floating-group">
          <input type="text" id="rl_depto" formControlName="tipo_departamento" />
          <label for="rl_depto">Depto. u oficina (opcional)</label>
        </div>
        <div class="floating-group">
          <input type="text" id="rl_comuna" formControlName="comuna" />
          <label for="rl_comuna">Comuna</label>
        </div>
      </div>

      <div class="form-grid">
        <div class="floating-group">
          <input type="text" id="rl_ciudad" formControlName="ciudad" />
          <label for="rl_ciudad">Ciudad</label>
        </div>
        <div class="floating-group">
          <select id="rl_pais" formControlName="pais_direccion">
            <option value="" disabled hidden></option>
            <option *ngFor="let country of countries" [value]="country.name">
              {{ country.name }}
            </option>
          </select>
          <label for="rl_pais">País</label>
        </div>
      </div>

      <p class="field-error" *ngIf="isFieldInvalid('direccion_particular') || isFieldInvalid('comuna') || isFieldInvalid('ciudad') || isFieldInvalid('pais_direccion')">
        Completa la dirección, comuna, ciudad y país.
      </p>

      <!-- Acciones -->
      <div class="actions">
        <button type="submit" class="continue-btn">Continuar</button>
        <button type="button" class="back-btn" (click)="goBack()">Volver</button>
      </div>
    </form>
  </ng-container>
</div>
